/**
 * @group UI
 * @summary URL path constants for frontend page navigation
 *
 * @remarks
 * These are the actual URL paths used for client-side and server-side
 * navigation (e.g. `router.push`, `redirect`). They are distinct from
 * `PAGE_RESOURCES` which contains RBAC resource identifiers.
 *
 * @example
 * ```typescript
 * import { PAGE_PATHS } from '@shared/constants';
 *
 * router.push(PAGE_PATHS.DASHBOARD_CONSULTATIONS);
 * redirect(PAGE_PATHS.SIGN_IN);
 * router.push(PAGE_PATHS.DASHBOARD_TELEHEALTH('abc-123'));
 * ```
 */
export const PAGE_PATHS = {
  SIGN_IN: '/users/signin',
  DASHBOARD: '/dashboard',
  DASHBOARD_CONSULTATIONS: '/dashboard/consultations',
  DASHBOARD_TELEHEALTH: (consultationId: string) =>
    `/dashboard/telehealth/${consultationId}`,
} as const;
